import reportRows from "./rapportkatalog.json";
import type { ReportCatalogEntry, ReportSortDirection, ReportSortKey } from "./types";

const defaultSortKey: ReportSortKey = "title";
const defaultSortDirection: ReportSortDirection = "asc";

function normalize(value: string): string {
    return value.toLocaleLowerCase("nb").trim();
}

export function getRapportkatalogRows(): ReportCatalogEntry[] {
    return reportRows as ReportCatalogEntry[];
}

export function filterRapportRows(rows: ReportCatalogEntry[], searchTerm: string): ReportCatalogEntry[] {
    const needle = normalize(searchTerm);

    if (needle.length === 0) {
        return rows;
    }

    return rows.filter((row) => {
        return [row.title, row.area, row.owner, row.targetGroups, row.shortDescription]
            .map(normalize)
            .some((value) => value.includes(needle));
    });
}

export function sortRapportRows(
    rows: ReportCatalogEntry[],
    sortKey: ReportSortKey = defaultSortKey,
    sortDirection: ReportSortDirection = defaultSortDirection,
): ReportCatalogEntry[] {
    const sorted = [...rows];

    sorted.sort((left, right) => {
        const result = left[sortKey].localeCompare(right[sortKey], "nb", {
            sensitivity: "base",
            numeric: true,
        });

        return sortDirection === "asc" ? result : -result;
    });

    return sorted;
}

export { defaultSortDirection, defaultSortKey };
